import randomId from 'random-id';
import { generateOtpComponentRef } from './consts';
import { phoneNumberCountryCode } from '../../apiUtils';

export default function (editor, opts = {}) {
  const c = opts;
  const domc = editor.DomComponents;

  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const formId = 'dc-form-' + randomId(8, '');

  domc.addType(generateOtpComponentRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: ':not(form)',
          draggable: ':not(form)',
          icon: '<i class="wb webconnect-lock-fill"></i>',
          name: 'OTP Generation Form',
          resizable: true,
          attributes: {
            id: formId,
          },
          traits: [
            {
              type: 'select',
              label: 'OTP Generation Method',
              name: 'otpGenerationMethod',
              value: '',
              changeProp: 1,
              options: [
                { id: '', name: '- Select One -' },
                { id: 'email', name: 'Email' },
                { id: 'sms', name: 'SMS' },
              ],
            },
            {
              type: 'checkbox',
              label: 'Enable Password',
              name: 'enablePassword',
              value: false,
              changeProp: 1,
            },
            {
              type: 'webconnect-event',
              label: 'Event',
              name: 'onsubmit',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
        },

        init() {
          this.listenTo(this, 'change:formState', this.updateFormState);
          this.listenTo(this, 'change:otpGenerationMethod', this.updateInputField);
          this.listenTo(this, 'change:otpGenerationMethod', this.updateCountryCodeTrait);
          this.listenTo(this, 'change:enablePassword', this.updatePasswordField);
          this.listenTo(this, 'change:defaultCountryCode', this.applyDefaultCountryCode);
          this.updateCountryCodeTrait();
        },
        updateInputField() {
          const method = this.get('otpGenerationMethod');
          const component = editor.getSelected();
          const otpGenerationMethodField = component.find('[otp-generation-form]')[0];

          if (!otpGenerationMethodField) {
            console.error('OTP Generation Method field not found.');
            return;
          }
          let otpMethodFieldHTML = '';
          if (method === 'email') {
            otpMethodFieldHTML = `<label>Email</label>
                                  <input name="email" 
                                  type="text" 
                                  placeholder="Enter Email" 
                                  class="form-control input--style" required/>`;
          } else if (method === 'sms') {
            otpMethodFieldHTML = `<label>Phone Number</label>
                                  <input name="phone_number" 
                                  type="tel" 
                                  placeholder="Enter Phone Number" 
                                  class="form-control input--style" required />`;
          } else {
            otpMethodFieldHTML = `<label>OTP Generation Method</label>
                                  <input name="otpGenerationMethod" 
                                  type="text" 
                                  placeholder="OTP Generation Method" 
                                  class="form-control input--style" required/>`;
          }
          otpGenerationMethodField.components(otpMethodFieldHTML);
          this.updatePasswordField();
        },
        updatePasswordField() {
          const enablePassword = this.get('enablePassword');
          const component = editor.getSelected();
          const otpGenerationMethodField = component.find('[otp-generation-form]')[0];
          if (!otpGenerationMethodField) {
            console.error('OTP Generation Method field not found.');
            return;
          }
          const passwordFieldWrapper = otpGenerationMethodField.find('#password-field')[0];
          if (enablePassword) {
            if (!passwordFieldWrapper) {
              otpGenerationMethodField.append(`
                <div class="form-group" id="password-field">
                  <label>Password</label>
                  <input name="password" 
                  type="password" 
                  placeholder="Enter Password" 
                  class="form-control input--style" />
                </div>
              `);
            }
          } else {
            if (passwordFieldWrapper) {
              passwordFieldWrapper.remove();
            }
          }
        },
        updateCountryCodeTrait() {
          const method = this.get('otpGenerationMethod');
          let traits = this.get('traits').slice();
          traits = traits.filter((t) => t.name !== 'defaultCountryCode');
          if (method === 'sms') {
            traits.push({
              type: 'select',
              label: 'Default Country Code',
              name: 'defaultCountryCode',
              changeProp: 1,
              options: [{ id: '', name: '- Select Country Code -' }, ...phoneNumberCountryCode],
            });
          }
          this.set('traits', traits);
        },
        applyDefaultCountryCode() {
          const defaultCode = this.get('defaultCountryCode');
          const component = editor.getSelected();
          if (!component) return;
          const telInput = component.find('input[name="phone_number"]')[0];
          if (!telInput) return;
          telInput.addAttributes({
            defaultCountry: defaultCode || '',
          });
        },
        updateFormState() {
          var state = this.get('formState');
          switch (state) {
            case 'success':
              this.showState('success');
              break;
            case 'error':
              this.showState('error');
              break;
            default:
              this.showState('normal');
          }
        },

        showState(state) {
          var st = state || 'normal';
          var failVis, successVis;
          if (st === 'success') {
            failVis = 'none';
            successVis = 'block';
          } else if (st === 'error') {
            failVis = 'block';
            successVis = 'none';
          } else {
            failVis = 'none';
            successVis = 'none';
          }
          var successModel = this.getStateModel('success');
          var failModel = this.getStateModel('error');
          var successStyle = successModel.getStyle();
          var failStyle = failModel.getStyle();
          successStyle.display = successVis;
          failStyle.display = failVis;
          successModel.setStyle(successStyle);
          failModel.setStyle(failStyle);
        },

        getStateModel(state) {
          var st = state || 'success';
          var stateName = 'form-state-' + st;
          var stateModel;
          var comps = this.get('components');
          for (var i = 0; i < comps.length; i++) {
            var model = comps.models[i];
            if (model.get('form-state-type') === st) {
              stateModel = model;
              break;
            }
          }
          if (!stateModel) {
            var contentStr = formMsgSuccess;
            if (st === 'error') {
              contentStr = formMsgError;
            }
            stateModel = comps.add({
              'form-state-type': st,
              type: 'text',
              removable: false,
              copyable: false,
              draggable: false,
              attributes: { 'data-form-state': st },
              content: contentStr,
            });
          }
          return stateModel;
        },
      },
      {
        isComponent(el) {
          if (el.tagName === 'FORM' && el.getAttribute('data-gjs-type') === 'otp-generation-form') {
            return { type: generateOtpComponentRef };
          }
        },
      },
    ),

    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
    }),
  });
}
